/**
 * 组件 根组件
 */
import React, { Component, Suspense } from "react";
import { BrowserRouter, Route, Switch, withRouter } from "react-router-dom";
import PrivateRoute from "@src/components/PrivateRoute";
import storage from "@src/utils/storage";
import routerHistory from "@src/utils/routerHistory";
import { iosKeyboardUp } from "@src/utils/utils";
import { getCookie } from "@src/utils/cookie";
import { verifySafeCode } from "@src/api/safeCodeVerify";
import "./App.less";
import RouteList from "./router";
iosKeyboardUp();

const VERIFY_PAGE = "https://websafeverify.beijingfundtown.com";

/** 地址包含 local（如 localhost）则不跳转人机验证，方便本地运行 */
function isLocalEnv() {
  return typeof window !== "undefined" && window.location.hostname.toLowerCase().indexOf("local") !== -1;
}

let prePath = '/';

class App extends Component {



  // 设置标签栏title
  setTitle = (title) => {
    // console.log("调用了", title);
    document.title = title;
  };
  // 存储除了登录每次的访问地址
  setFormPath = (path) => {
    if (
      path !== "/login" &&
      path !== "/binding" &&
      path !== "/personal" &&
      path !== "/tansferStation" &&
      path !== "/identityPage"&&
      path.indexOf("/solicitation")===-1
    ) {
      storage.setFromPath(path);
      // alert("调用了路由存储")
      routerHistory.fromPath = path;
    }
  };

  componentDidCatch(error, info) {
    console.log("Error::::", error);
    console.log("info", info);
    if (String(error).includes("Loading chunk")||String(error).includes("Loading CSS chunk")) {
      window.location.reload();
    }
  };

  componentDidMount() {
    prePath = window.location.href;
  }


  umengSend(props) {
    if (window._czc) {
      let location = window.location;
      let contentUrl = location.pathname + location.hash;
      window._czc.push(["_trackPageview", contentUrl, prePath]);
      prePath = props.location.pathname
      //友盟统计数据，单页面应用需要监听路由跳转
      const hm=document.createElement('script');
      hm.src="https://s4.cnzz.com/z_stat.php?id=1280170972&web_id=1280170972";
      const s=document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(hm,s)
    }
  }
  // 路由变化时：用 cookie 中的 safe_code 调校验接口，无效则跳转人机验证页（本地环境不跳转）
  checkAndRedirectIfNeeded = () => {
    if (isLocalEnv()) return;
     // 防止重复跳转到验证页（避免循环）
  if (window.location.href.includes(VERIFY_PAGE)) {
    console.log("已在验证页，不再跳转");
    return;
  }

  verifySafeCode(getCookie("safe_code"))
    .then((res) => {
      // 强化判断：确保 res 存在且结构正确
      if (!res) {
        console.warn("验证接口返回空，跳转验证");
        return this.toHumanVerification();
      }

      const code = res.code;
      if (code === 0) {
        console.log("验证通过");
        return;
      } else {
        console.warn("验证未通过，跳转人机验证", res);
        this.toHumanVerification();
      }
    })
    .catch((err) => {
      console.error("验证接口请求失败", err);
      // 网络错误、CORS、JSON 解析失败等
      this.toHumanVerification(); // 安全起见，跳转验证
    });
  };

  toHumanVerification = () => {
    if (isLocalEnv()) return;
    const redirect = encodeURIComponent(window.location.href);
    window.location.href = `${VERIFY_PAGE}?redirect=${redirect}`;
  };

  render() {
    const { setTitle, setFormPath, umengSend, checkAndRedirectIfNeeded } = this;
    return (
      <BrowserRouter>
        <AppRoutes
          setTitle={setTitle}
          setFormPath={setFormPath}
          umengSend={umengSend}
          onRouteChange={checkAndRedirectIfNeeded}
        />
      </BrowserRouter>
    );
  }
}

// 放在 Router 内部，用 withRouter 拿到 location，路由变化时校验 safe_code，不通过则跳人机验证
class AppRoutesClass extends Component {
  componentDidUpdate(prevProps) {
    const { location, onRouteChange } = this.props;
    if (!location || !onRouteChange) return;
    if (prevProps.location && prevProps.location.pathname !== location.pathname) {
      onRouteChange();
    }
  }

  render() {
    const { setTitle, setFormPath, umengSend } = this.props;
    return (
      <Switch>
        {RouteList.map((route, index) => {
          const { path, Component, title, exact, isPrivate } = route;
          return isPrivate === true ? (
            <PrivateRoute
              key={index}
              exact={exact}
              path={`${path}`}
              render={(props) => {
                setTitle(title);
                setFormPath(props.location.pathname);
                umengSend(props);
                return (
                  <Suspense fallback={<Loading />}>
                    <Component {...props} />
                  </Suspense>
                );
              }}
            />
          ) : (
            <Route
              key={index}
              exact={exact}
              path={`${path}`}
              render={(props) => {
                setTitle(title);
                setFormPath(props.location.pathname);
                umengSend(props);
                return (
                  <Suspense fallback={<Loading />}>
                    <Component {...props} />
                  </Suspense>
                );
              }}
            />
          );
        })}
      </Switch>
    );
  }
}
const AppRoutes = withRouter(AppRoutesClass);

const Loading = () => {
  return (
    <div className="loading">
      <div className="loading-text">数据加载中</div>
    </div>
  );
};
export default App;

